export enum PermissionName {
    DisplaysAnalogue_screensCreate = 'displays.analogue_screens.create',
    DisplaysAnalogue_screensRead = 'displays.analogue_screens.read',
    DisplaysAnalogue_screensUpdate = 'displays.analogue_screens.update',
    DisplaysAnalogue_screensDestroy = 'displays.analogue_screens.destroy',
    DisplaysCountriesCreate = 'displays.countries.create',
    DisplaysCountriesRead = 'displays.countries.read',
    DisplaysCountriesUpdate = 'displays.countries.update',
    DisplaysCountriesDestroy = 'displays.countries.destroy',
    DisplaysCountry_ownerCreate = 'displays.country_owner.create',
    DisplaysCountry_ownerRead = 'displays.country_owner.read',
    DisplaysCountry_ownerUpdate = 'displays.country_owner.update',
    DisplaysCountry_ownerDestroy = 'displays.country_owner.destroy',
    DisplaysCurrenciesCreate = 'displays.currencies.create',
    DisplaysCurrenciesRead = 'displays.currencies.read',
    DisplaysCurrenciesUpdate = 'displays.currencies.update',
    DisplaysCurrenciesDestroy = 'displays.currencies.destroy',
    DisplaysDisplays_import_requestsCreate = 'displays.displays_import_requests.create',
    DisplaysDisplays_import_requestsRead = 'displays.displays_import_requests.read',
    DisplaysDisplays_import_requestsUpdate = 'displays.displays_import_requests.update',
    DisplaysDisplays_import_requestsDestroy = 'displays.displays_import_requests.destroy',
    DisplaysFile_typesCreate = 'displays.file_types.create',
    DisplaysFile_typesRead = 'displays.file_types.read',
    DisplaysFile_typesUpdate = 'displays.file_types.update',
    DisplaysFile_typesDestroy = 'displays.file_types.destroy',
    DisplaysFile_type_groupsCreate = 'displays.file_type_groups.create',
    DisplaysFile_type_groupsRead = 'displays.file_type_groups.read',
    DisplaysFile_type_groupsUpdate = 'displays.file_type_groups.update',
    DisplaysFile_type_groupsDestroy = 'displays.file_type_groups.destroy',
    DisplaysFrame_typesCreate = 'displays.frame_types.create',
    DisplaysFrame_typesRead = 'displays.frame_types.read',
    DisplaysFrame_typesUpdate = 'displays.frame_types.update',
    DisplaysFrame_typesDestroy = 'displays.frame_types.destroy',
    DisplaysIlluminationsCreate = 'displays.illuminations.create',
    DisplaysIlluminationsRead = 'displays.illuminations.read',
    DisplaysIlluminationsUpdate = 'displays.illuminations.update',
    DisplaysIlluminationsDestroy = 'displays.illuminations.destroy',
    DisplaysMarket_ownerCreate = 'displays.market_owner.create',
    DisplaysMarket_ownerRead = 'displays.market_owner.read',
    DisplaysMarket_ownerUpdate = 'displays.market_owner.update',
    DisplaysMarket_ownerDestroy = 'displays.market_owner.destroy',
    DisplaysOperational_timesCreate = 'displays.operational_times.create',
    DisplaysOperational_timesRead = 'displays.operational_times.read',
    DisplaysOperational_timesUpdate = 'displays.operational_times.update',
    DisplaysOperational_timesDestroy = 'displays.operational_times.destroy',
    DisplaysOwnersCreate = 'displays.owners.create',
    DisplaysOwnersRead = 'displays.owners.read',
    DisplaysOwnersUpdate = 'displays.owners.update',
    DisplaysOwnersDestroy = 'displays.owners.destroy',
    DisplaysPacksCreate = 'displays.packs.create',
    DisplaysPacksRead = 'displays.packs.read',
    DisplaysPacksUpdate = 'displays.packs.update',
    DisplaysPacksDestroy = 'displays.packs.destroy',
    DisplaysPartnersCreate = 'displays.partners.create',
    DisplaysPartnersRead = 'displays.partners.read',
    DisplaysPartnersUpdate = 'displays.partners.update',
    DisplaysPartnersDestroy = 'displays.partners.destroy',
    DisplaysPartner_space_displaysCreate = 'displays.partner_space_displays.create',
    DisplaysPartner_space_displaysRead = 'displays.partner_space_displays.read',
    DisplaysPartner_space_displaysUpdate = 'displays.partner_space_displays.update',
    DisplaysPartner_space_displaysDestroy = 'displays.partner_space_displays.destroy',
    DisplaysScreensCreate = 'displays.screens.create',
    DisplaysScreensRead = 'displays.screens.read',
    DisplaysScreensUpdate = 'displays.screens.update',
    DisplaysScreensDestroy = 'displays.screens.destroy',
    DisplaysScreen_packCreate = 'displays.screen_pack.create',
    DisplaysScreen_packRead = 'displays.screen_pack.read',
    DisplaysScreen_packUpdate = 'displays.screen_pack.update',
    DisplaysScreen_packDestroy = 'displays.screen_pack.destroy',
    DisplaysScreen_tagCreate = 'displays.screen_tag.create',
    DisplaysScreen_tagRead = 'displays.screen_tag.read',
    DisplaysScreen_tagUpdate = 'displays.screen_tag.update',
    DisplaysScreen_tagDestroy = 'displays.screen_tag.destroy',
    DisplaysTagsCreate = 'displays.tags.create',
    DisplaysTagsRead = 'displays.tags.read',
    DisplaysTagsUpdate = 'displays.tags.update',
    DisplaysTagsDestroy = 'displays.tags.destroy',
    DisplaysV_displaysCreate = 'displays.v_displays.create',
    DisplaysV_displaysRead = 'displays.v_displays.read',
    DisplaysV_displaysUpdate = 'displays.v_displays.update',
    DisplaysV_displaysDestroy = 'displays.v_displays.destroy',
    DisplaysV_sites_packsCreate = 'displays.v_sites_packs.create',
    DisplaysV_sites_packsRead = 'displays.v_sites_packs.read',
    DisplaysV_sites_packsUpdate = 'displays.v_sites_packs.update',
    DisplaysV_sites_packsDestroy = 'displays.v_sites_packs.destroy',
    DisplaysV_sites_packs_displaysCreate = 'displays.v_sites_packs_displays.create',
    DisplaysV_sites_packs_displaysRead = 'displays.v_sites_packs_displays.read',
    DisplaysV_sites_packs_displaysUpdate = 'displays.v_sites_packs_displays.update',
    DisplaysV_sites_packs_displaysDestroy = 'displays.v_sites_packs_displays.destroy',
    Pop_displaysChannel_framesCreate = 'pop_displays.channel_frames.create',
    Pop_displaysChannel_framesRead = 'pop_displays.channel_frames.read',
    Pop_displaysChannel_framesUpdate = 'pop_displays.channel_frames.update',
    Pop_displaysChannel_framesDestroy = 'pop_displays.channel_frames.destroy',
    DisplaysDisplay_channel_frameCreate = 'displays.display_channel_frame.create',
    DisplaysDisplay_channel_frameRead = 'displays.display_channel_frame.read',
    DisplaysDisplay_channel_frameUpdate = 'displays.display_channel_frame.update',
    DisplaysDisplay_channel_frameDestroy = 'displays.display_channel_frame.destroy',
    Pop_displaysJob_statusesCreate = 'pop_displays.job_statuses.create',
    Pop_displaysJob_statusesRead = 'pop_displays.job_statuses.read',
    Pop_displaysJob_statusesUpdate = 'pop_displays.job_statuses.update',
    Pop_displaysJob_statusesDestroy = 'pop_displays.job_statuses.destroy',
    Pop_displaysLog_file_importsCreate = 'pop_displays.log_file_imports.create',
    Pop_displaysLog_file_importsRead = 'pop_displays.log_file_imports.read',
    Pop_displaysLog_file_importsUpdate = 'pop_displays.log_file_imports.update',
    Pop_displaysLog_file_importsDestroy = 'pop_displays.log_file_imports.destroy',
    Pop_displaysLog_file_parsedCreate = 'pop_displays.log_file_parsed.create',
    Pop_displaysLog_file_parsedRead = 'pop_displays.log_file_parsed.read',
    Pop_displaysLog_file_parsedUpdate = 'pop_displays.log_file_parsed.update',
    Pop_displaysLog_file_parsedDestroy = 'pop_displays.log_file_parsed.destroy',
    Pop_displaysLog_file_resourcesCreate = 'pop_displays.log_file_resources.create',
    Pop_displaysLog_file_resourcesRead = 'pop_displays.log_file_resources.read',
    Pop_displaysLog_file_resourcesUpdate = 'pop_displays.log_file_resources.update',
    Pop_displaysLog_file_resourcesDestroy = 'pop_displays.log_file_resources.destroy',
    Pop_displaysLog_file_storeCreate = 'pop_displays.log_file_store.create',
    Pop_displaysLog_file_storeRead = 'pop_displays.log_file_store.read',
    Pop_displaysLog_file_storeUpdate = 'pop_displays.log_file_store.update',
    Pop_displaysLog_file_storeDestroy = 'pop_displays.log_file_store.destroy',
    Pop_displaysLog_import_sourceCreate = 'pop_displays.log_import_source.create',
    Pop_displaysLog_import_sourceRead = 'pop_displays.log_import_source.read',
    Pop_displaysLog_import_sourceUpdate = 'pop_displays.log_import_source.update',
    Pop_displaysLog_import_sourceDestroy = 'pop_displays.log_import_source.destroy',
    Pop_displaysMediaCreate = 'pop_displays.media.create',
    Pop_displaysMediaRead = 'pop_displays.media.read',
    Pop_displaysMediaUpdate = 'pop_displays.media.update',
    Pop_displaysMediaDestroy = 'pop_displays.media.destroy',
    UniledportalAgencyCreate = 'uniledportal.agency.create',
    UniledportalAgencyRead = 'uniledportal.agency.read',
    UniledportalAgencyUpdate = 'uniledportal.agency.update',
    UniledportalAgencyDestroy = 'uniledportal.agency.destroy',
    UniledportalAgency_userCreate = 'uniledportal.agency_user.create',
    UniledportalAgency_userRead = 'uniledportal.agency_user.read',
    UniledportalAgency_userUpdate = 'uniledportal.agency_user.update',
    UniledportalAgency_userDestroy = 'uniledportal.agency_user.destroy',
    UniledportalBuyerCreate = 'uniledportal.buyer.create',
    UniledportalBuyerRead = 'uniledportal.buyer.read',
    UniledportalBuyerUpdate = 'uniledportal.buyer.update',
    UniledportalBuyerDestroy = 'uniledportal.buyer.destroy',
    UniledportalBuyer_userCreate = 'uniledportal.buyer_user.create',
    UniledportalBuyer_userRead = 'uniledportal.buyer_user.read',
    UniledportalBuyer_userUpdate = 'uniledportal.buyer_user.update',
    UniledportalBuyer_userDestroy = 'uniledportal.buyer_user.destroy',
    UniledportalCampaignCreate = 'uniledportal.campaign.create',
    UniledportalCampaignRead = 'uniledportal.campaign.read',
    UniledportalCampaignUpdate = 'uniledportal.campaign.update',
    UniledportalCampaignDestroy = 'uniledportal.campaign.destroy',
    UniledportalCampaign_displayCreate = 'uniledportal.campaign_display.create',
    UniledportalCampaign_displayRead = 'uniledportal.campaign_display.read',
    UniledportalCampaign_displayUpdate = 'uniledportal.campaign_display.update',
    UniledportalCampaign_displayDestroy = 'uniledportal.campaign_display.destroy',
    UniledportalCampaign_display_date_creativeCreate = 'uniledportal.campaign_display_date_creative.create',
    UniledportalCampaign_display_date_creativeRead = 'uniledportal.campaign_display_date_creative.read',
    UniledportalCampaign_display_date_creativeUpdate = 'uniledportal.campaign_display_date_creative.update',
    UniledportalCampaign_display_date_creativeDestroy = 'uniledportal.campaign_display_date_creative.destroy',
    UniledportalCampaign_ownerCreate = 'uniledportal.campaign_owner.create',
    UniledportalCampaign_ownerRead = 'uniledportal.campaign_owner.read',
    UniledportalCampaign_ownerUpdate = 'uniledportal.campaign_owner.update',
    UniledportalCampaign_ownerDestroy = 'uniledportal.campaign_owner.destroy',
    UniledportalClientCreate = 'uniledportal.client.create',
    UniledportalClientRead = 'uniledportal.client.read',
    UniledportalClientUpdate = 'uniledportal.client.update',
    UniledportalClientDestroy = 'uniledportal.client.destroy',
    UniledportalClient_userCreate = 'uniledportal.client_user.create',
    UniledportalClient_userRead = 'uniledportal.client_user.read',
    UniledportalClient_userUpdate = 'uniledportal.client_user.update',
    UniledportalClient_userDestroy = 'uniledportal.client_user.destroy',
    UniledportalCreativeCreate = 'uniledportal.creative.create',
    UniledportalCreativeRead = 'uniledportal.creative.read',
    UniledportalCreativeUpdate = 'uniledportal.creative.update',
    UniledportalCreativeDestroy = 'uniledportal.creative.destroy',
    UniledportalCreative_userCreate = 'uniledportal.creative_user.create',
    UniledportalCreative_userRead = 'uniledportal.creative_user.read',
    UniledportalCreative_userUpdate = 'uniledportal.creative_user.update',
    UniledportalCreative_userDestroy = 'uniledportal.creative_user.destroy',
    UniledportalFileCreate = 'uniledportal.file.create',
    UniledportalFileRead = 'uniledportal.file.read',
    UniledportalFileUpdate = 'uniledportal.file.update',
    UniledportalFileDestroy = 'uniledportal.file.destroy',
    UniledPortalHappyDemicsRead = 'uniledportal.happydemics.read',
    UniledportalMarketCreate = 'uniledportal.market.create',
    UniledportalMarketRead = 'uniledportal.market.read',
    UniledportalMarketUpdate = 'uniledportal.market.update',
    UniledportalMarketDestroy = 'uniledportal.market.destroy',
    UniledportalOwner_userCreate = 'uniledportal.owner_user.create',
    UniledportalOwner_userRead = 'uniledportal.owner_user.read',
    UniledportalOwner_userUpdate = 'uniledportal.owner_user.update',
    UniledportalOwner_userDestroy = 'uniledportal.owner_user.destroy',
    UniledportalQueue_cronCreate = 'uniledportal.queue_cron.create',
    UniledportalQueue_cronRead = 'uniledportal.queue_cron.read',
    UniledportalQueue_cronUpdate = 'uniledportal.queue_cron.update',
    UniledportalQueue_cronDestroy = 'uniledportal.queue_cron.destroy',
    UniledportalResolutionCreate = 'uniledportal.resolution.create',
    UniledportalResolutionRead = 'uniledportal.resolution.read',
    UniledportalResolutionUpdate = 'uniledportal.resolution.update',
    UniledportalResolutionDestroy = 'uniledportal.resolution.destroy',
    UniledportalUserCreate = 'uniledportal.user.create',
    UniledportalUserRead = 'uniledportal.user.read',
    UniledportalUserUpdate = 'uniledportal.user.update',
    UniledportalUserDestroy = 'uniledportal.user.destroy',
    UniledportalCampaign_userCreate = 'uniledportal.campaign_user.create',
    UniledportalCampaign_userRead = 'uniledportal.campaign_user.read',
    UniledportalCampaign_userUpdate = 'uniledportal.campaign_user.update',
    UniledportalCampaign_userDestroy = 'uniledportal.campaign_user.destroy',
    ReportingPcareportRead = 'reporting.pcareport.read',
    PowerpointPcareportRead = 'reporting.powerpoint',
    PdfPcaReportRead = 'reporting.pdf',
    UniledportalSkinCreate = 'uniledportal.skin.create',
    UniledportalSkinRead = 'uniledportal.skin.read',
    UniledportalSkinUpdate = 'uniledportal.skin.update',
    UniledportalSkinDestroy = 'uniledportal.skin.destroy',
    UniledportalEarly_access = 'uniledportal.early_access',
    UniledportalRoleDestroy = 'uniledportal.role.destroy',
    UniledportalRoleUpdate = 'uniledportal.role.update',
    UniledportalRoleRead = 'uniledportal.role.read',
    UniledportalRoleCreate = 'uniledportal.role.create',
    AdminScopingCampaignIgnore = 'admin.scoping.campaign.ignore',
    Admin = 'admin',
    AdminScopingClientIgnore = 'admin.scoping.client.ignore',
    AdminScopingCreativeIgnore = 'admin.scoping.creative.ignore',
    AdminCan_impersonate_user = 'admin.can_impersonate_user',
    AdminCan_view_usage = 'admin.can_view_usage',
    UniledportalCampaignCreativeDownload = 'uniledportal.campaign.creative.download',
    UniledportalCampaignSpecsDownload = 'uniledportal.campaign.specs.download',
    AdminCan_change_passwords = 'admin.can_change_passwords',
    FilteringCampaignClient = 'filtering.campaign.client',
    FilteringCampaignBuyer = 'filtering.campaign.buyer',
    FilteringCampaignMarket = 'filtering.campaign.market',
    UniledportalBuyer_costCreate = 'uniledportal.buyer_cost.create',
    UniledportalBuyer_costRead = 'uniledportal.buyer_cost.read',
    UniledportalBudget_summaryStatus_change = 'uniledportal.budget_summary.status_change',
    UniledportalBudget_summaryOverride = 'uniledportal.budget_summary.override',
    DisplaysLine_itemsCreate = 'displays.line_items.create',
    DisplaysLine_itemsRead = 'displays.line_items.read',
    UniledportalBudget_summary_line_itemCreate = 'uniledportal.budget_summary_line_item.create',
    UniledportalBudget_summary_line_itemRead = 'uniledportal.budget_summary_line_item.read',
    UniledportalBudget_summary_line_itemUpdate = 'uniledportal.budget_summary_line_item.update',
    UniledportalBudget_summaryCreate = 'uniledportal.budget_summary.create',
    UniledportalBudget_summaryRead = 'uniledportal.budget_summary.read',
    UniledportalBudget_summaryUpdate = 'uniledportal.budget_summary.update',
    AdminScopingBuyersIgnore = 'admin.scoping.buyers.ignore',
    AdminScopingLine_itemsIgnore = 'admin.scoping.line_items.ignore',
    AdminScopingMarketsIgnore = 'admin.scoping.markets.ignore',
    DisplaysDisplay_issuesCreate = 'displays.display_issues.create',
    DisplaysDisplay_issuesRead = 'displays.display_issues.read',
    DisplaysDisplay_issuesUpdate = 'displays.display_issues.update',
    DisplaysDisplay_issuesDelete = 'displays.display_issues.delete',
    AdminCan_set_display_notices = 'admin.can_set_display_notices',
    DisplaysLine_item_linksRead = 'displays.line_item_links.read',
    DisplaysDisplay_issues_pivotRead = 'displays.display_issues_pivot.read',
    UniledportalCreative_groupCreate = 'uniledportal.creative_group.create',
    UniledportalCreative_groupRead = 'uniledportal.creative_group.read',
    UniledportalCreative_groupUpdate = 'uniledportal.creative_group.update',
    UniledportalCreative_groupDestroy = 'uniledportal.creative_group.destroy',
    AdminCan_read_pca_sandbox = 'admin.can_read_pca_sandbox',
    Pop_displaysPca_reports_rawRead = 'pop_displays.pca_reports_raw.read',
    Pop_displaysPca_reports_rawUpdate = 'pop_displays.pca_reports_raw.update',
    Pop_displaysPca_reports_dailyRead = 'pop_displays.pca_reports_daily.read',
    Pop_displaysPca_reports_dailyUpdate = 'pop_displays.pca_reports_daily.update',
    ReportingPcareportDownload = 'reporting.pcareport.download',
    DashboardReporting = 'reporting.campaign_reports',
    UniledportalBuyer_costUpdate = 'uniledportal.buyer_cost.update',
    GeneralView_creatives = 'general.view_creatives',
    Internal_adminCampaign_sitelist_displayCreate = 'internal_admin.campaign_sitelist_display.create',
    Internal_adminCampaign_sitelist_displayRead = 'internal_admin.campaign_sitelist_display.read',
    Internal_adminCampaign_sitelist_displayUpdate = 'internal_admin.campaign_sitelist_display.update',
    Internal_adminCampaign_sitelist_displayDestroy = 'internal_admin.campaign_sitelist_display.destroy',
    UniledportalNotificationCreate = 'uniledportal.notification.create',
    UniledportalNotificationUpdate = 'uniledportal.notification.update',
    UniledportalCreativeDownload = 'uniledportal.creative.download',
    UniledportalCampaign_errorCreate = 'uniledportal.campaign_error.create',
    UniledportalCampaign_errorRead = 'uniledportal.campaign_error.read',
    UniledportalCampaign_errorUpdate = 'uniledportal.campaign_error.update',
    UniledportalCampaign_errorDestroy = 'uniledportal.campaign_error.destroy',
    Pop_displaysSitelistUpload = 'pop_displays.sitelist.upload',
    Pop_displaysVirtual_campaignCreate = 'pop_displays.virtual_campaign.create',
    AdminCampaignCan_be_internal_owner = 'admin.campaign.can_be_internal_owner',
    AdminCampaignCan_be_internal_assignee = 'admin.campaign.can_be_internal_assignee',
    UniledportalCampaign_booking_summariesCreate = 'uniledportal.campaign_booking_summaries.create',
    UniledportalCampaign_booking_summariesRead = 'uniledportal.campaign_booking_summaries.read',
    UniledportalCampaign_booking_summariesUpdate = 'uniledportal.campaign_booking_summaries.update',
    UniledportalCampaign_booking_summariesDestroy = 'uniledportal.campaign_booking_summaries.destroy',
    CampaignCan_invite_user = 'campaign.can_invite_user',
    DisplaysResolutionsRead = 'displays.resolutions.read',
    GeneralView_data_status = 'general.view_data_status',
    GeneralView_data_status_booking = 'general.view_data_status_booking',
    UniledportalCreativeStart_end_dateEdit = 'uniledportal.creative.start_end_date.edit',
    DisplaysAudience_versionRead = 'displays.audience_version.read',
    DisplaysAudience_sourceRead = 'displays.audience_source.read',
    Pop_displaysLog_source_accountsCreate = 'pop_displays.log_source_accounts.create',
    Pop_displaysLog_source_accountsRead = 'pop_displays.log_source_accounts.read',
    Pop_displaysLog_source_accountsUpdate = 'pop_displays.log_source_accounts.update',
    Pop_displaysLog_source_campaign_identifierCreate = 'pop_displays.log_source_campaign_identifier.create',
    Pop_displaysLog_source_campaign_identifierRead = 'pop_displays.log_source_campaign_identifier.read',
    Pop_displaysLog_source_campaign_identifierUpdate = 'pop_displays.log_source_campaign_identifier.update',
    Internal_adminCampaign_missing_displaysCreate = 'internal_admin.campaign_missing_displays.create',
    Internal_adminCampaign_missing_displaysRead = 'internal_admin.campaign_missing_displays.read',
    Internal_adminCampaign_missing_displaysUpdate = 'internal_admin.campaign_missing_displays.update',
    Internal_adminCampaign_missing_displaysDestroy = 'internal_admin.campaign_missing_displays.destroy',
    UniledportalLogin_attemptsCreate = 'uniledportal.login_attempts.create',
    UniledportalLogin_attemptsRead = 'uniledportal.login_attempts.read',
    UniledportalLogin_attemptsUpdate = 'uniledportal.login_attempts.update',
    UniledportalLogin_attemptsDestroy = 'uniledportal.login_attempts.destroy',
    DisplaysDisplays_vendor_idsCreate = 'displays.displays_vendor_ids.create',
    DisplaysDisplays_vendor_idsRead = 'displays.displays_vendor_ids.read',
    DisplaysDisplays_vendor_idsUpdate = 'displays.displays_vendor_ids.update',
    DisplaysDisplays_vendor_idsDestroy = 'displays.displays_vendor_ids.destroy',
    Pop_displaysDisplaysLog_file_parsed_mediaRead = 'pop_displays.displays.log_file_parsed_media.read',
    Pop_displaysLog_file_parsedPlayout_export = 'pop_displays.log_file_parsed.playout_export',
    UniledportalLocaleRead = 'uniledportal.locale.read',
    GeneralReset_data_status = 'general.reset_data_status',
    UniledportalCampaign_instructionsCreate = 'uniledportal.campaign_instructions.create',
    UniledportalCampaign_instructionsRead = 'uniledportal.campaign_instructions.read',
    UniledportalCampaign_instructionsUpdate = 'uniledportal.campaign_instructions.update',
    UniledportalCampaign_instruction_filesCreate = 'uniledportal.campaign_instruction_files.create',
    UniledportalCampaign_instruction_filesRead = 'uniledportal.campaign_instruction_files.read',
    UniledportalCampaign_instruction_filesUpdate = 'uniledportal.campaign_instruction_files.update',
    UniledportalCreative_creative_groupCreate = 'uniledportal.creative_creative_group.create',
    UniledportalCreative_creative_groupRead = 'uniledportal.creative_creative_group.read',
    UniledportalCreative_creative_groupUpdate = 'uniledportal.creative_creative_group.update',
    UniledportalCreative_creative_groupDestroy = 'uniledportal.creative_creative_group.destroy',
    UniliveapiSchedulesCreate = 'uniliveapi.schedules.create',
    UniliveapiSchedulesRead = 'uniliveapi.schedules.read',
    UniliveapiSchedulesUpdate = 'uniliveapi.schedules.update',
    UniliveapiSchedulesDestroy = 'uniliveapi.schedules.destroy',
    UniliveapiRulesCreate = 'uniliveapi.rules.create',
    UniliveapiRulesRead = 'uniliveapi.rules.read',
    UniliveapiRulesUpdate = 'uniliveapi.rules.update',
    UniliveapiRulesDestroy = 'uniliveapi.rules.destroy',
    UniledportalAlertsCreate = 'uniledportal.alerts.create',
    UniledportalAlertsRead = 'uniledportal.alerts.read',
    UniledportalAlertsUpdate = 'uniledportal.alerts.update',
    UniledportalAlertsDestroy = 'uniledportal.alerts.destroy',
    UniledportalPortal_settingsCreate = 'uniledportal.portal_settings.create',
    UniledportalPortal_settingsRead = 'uniledportal.portal_settings.read',
    UniledportalPortal_settingsUpdate = 'uniledportal.portal_settings.update',
    UniledportalPortal_settingsDestroy = 'uniledportal.portal_settings.destroy',
    AdminScopingCreative_groupIgnore = 'admin.scoping.creative_group.ignore',
    UniledportalInviteRead = 'uniledportal.invite.read',
    UniliveapiSchedulesSitelist_upload = 'uniliveapi.schedules.sitelist_upload',
    DisplaysAudience_fallbackCreate = 'displays.audience_fallback.create',
    DisplaysAnalogue_screensBrochureDownload = 'displays.analogue_screens.brochure.download',
    Internal_adminCampaign_sitelistCreate = 'internal_admin.campaign_sitelist.create',
    Internal_adminCampaign_sitelistRead = 'internal_admin.campaign_sitelist.read',
    Internal_adminCampaign_sitelistUpdate = 'internal_admin.campaign_sitelist.update',
    Internal_adminCampaign_sitelistDestroy = 'internal_admin.campaign_sitelist.destroy',
    Internal_adminCampaign_sitelist_unknownCreate = 'internal_admin.campaign_sitelist_unknown.create',
    Internal_adminCampaign_sitelist_unknownRead = 'internal_admin.campaign_sitelist_unknown.read',
    Internal_adminCampaign_sitelist_unknownUpdate = 'internal_admin.campaign_sitelist_unknown.update',
    Internal_adminCampaign_sitelist_unknownDestroy = 'internal_admin.campaign_sitelist_unknown.destroy',
    DisplaysScreensImport = 'displays.screens.import',
    Pop_displaysChannel_framesExport = 'pop_displays.channel_frames.export',
    UniledportalCampaign_pop_shotsCreate = 'uniledportal.campaign_pop_shots.create',
    UniledportalCampaign_pop_shotsRead = 'uniledportal.campaign_pop_shots.read',
    UniledportalCampaign_pop_shotsUpdate = 'uniledportal.campaign_pop_shots.update',
    AdminScopingCampaign_pop_shotsIgnore = 'admin.scoping.campaign_pop_shots.ignore',
    UniledportalCampaign_pop_shotsDestroy = 'uniledportal.campaign_pop_shots.destroy',
    DisplaysAudienceRead = 'displays.audience.read',
    ImpressionMultiplierRead = 'reporting.impression_multipliers.read',

    // Granular admin permissions - split out of the blanket `admin` permission.
    AdminCampaignCad = 'admin.campaign.cad',
    AdminCampaignReporting_inputs = 'admin.campaign.reporting_inputs',
    AdminCampaignCustomize_summary = 'admin.campaign.customize_summary',
    AdminCampaignCustomize_pca = 'admin.campaign.customize_pca',
    AdminCampaignCreative_schedule_check = 'admin.campaign.creative_schedule_check',
    AdminCampaignIo_ids = 'admin.campaign.io_ids',
    AdminCampaignEdit_expected_impacts = 'admin.campaign.edit_expected_impacts',
    AdminCampaignEdit_bought_value = 'admin.campaign.edit_bought_value',
    AdminCampaignEdit_delivered_value = 'admin.campaign.edit_delivered_value',
    AdminCampaignUse_linear_reporting = 'admin.campaign.use_linear_reporting',
    AdminCampaignEdit_campaign_type = 'admin.campaign.edit_campaign_type',
    AdminCampaignPca_settings = 'admin.campaign.pca_settings',
    AdminCampaignPca_client_generation = 'admin.campaign.pca_client_generation',
    AdminCampaignLine_item_owner_users = 'admin.campaign.line_item_owner_users',
    AdminCampaignFrame_date_breakdown = 'admin.campaign.frame_date_breakdown',
    AdminCampaignAi_chat = 'admin.campaign.ai_chat',
    AdminCampaignNew_campaign_type = 'admin.campaign.new_campaign_type',
    AdminCampaignBuyer_search = 'admin.campaign.buyer_search',
    AdminPca_exportReport_type = 'admin.pca_export.report_type',
    AdminFilteringBypass_filter_permissions = 'admin.filtering.bypass_filter_permissions',
    AdminDisplaysMass_update = 'admin.displays.mass_update',
    AdminDisplaysManual_audience_upload = 'admin.displays.manual_audience_upload',
    AdminDisplaysAllocation = 'admin.displays.allocation',
    AdminDisplaysCsv_export = 'admin.displays.csv_export',
    AdminDisplaysReimport = 'admin.displays.reimport',

    // UL-7905 .. UL-7909 -- DSP insertion order targeting.
    Pop_displaysInsertion_ordersRead = 'pop_displays.insertion_orders.read',
    Pop_displaysCampaign_insertion_order_parametersCreate = 'pop_displays.campaign_insertion_order_parameters.create',
    Pop_displaysCampaign_insertion_order_parametersRead = 'pop_displays.campaign_insertion_order_parameters.read',
    Pop_displaysCampaign_insertion_order_parametersUpdate = 'pop_displays.campaign_insertion_order_parameters.update',
    Pop_displaysCampaign_insertion_order_parametersDestroy = 'pop_displays.campaign_insertion_order_parameters.destroy',
    Pop_displaysCampaign_insertion_ordersRead = 'pop_displays.campaign_insertion_orders.read',
    Pop_displaysCampaign_insertion_ordersDestroy = 'pop_displays.campaign_insertion_orders.destroy',
    Pop_displaysCampaign_insertion_ordersSync = 'pop_displays.campaign_insertion_orders.sync',
    Pop_displaysCampaign_insertion_order_detailsUpdate = 'pop_displays.campaign_insertion_order_details.update',
    UniledportalCampaign_insertion_order_scheduleRead = 'uniledportal.campaign_insertion_order_schedule.read',
    UniledportalCampaign_insertion_order_scheduleUpdate = 'uniledportal.campaign_insertion_order_schedule.update',
    Pop_displaysCampaign_allowed_venuesRead = 'pop_displays.campaign_allowed_venues.read',
    Pop_displaysCampaign_allowed_venuesCreate = 'pop_displays.campaign_allowed_venues.create',

    // Saved reporting configurations (summary / pca / dashboard) and their assignment.
    UniledportalCampaign_reportingCreate = 'uniledportal.campaign_reporting.create',
    UniledportalCampaign_reportingRead = 'uniledportal.campaign_reporting.read',
    UniledportalCampaign_reportingUpdate = 'uniledportal.campaign_reporting.update',
    UniledportalCampaign_reportingDestroy = 'uniledportal.campaign_reporting.destroy',
    UniledportalCampaign_reportingAssign = 'uniledportal.campaign_reporting.assign',

    // others permissions
    // View2Fill -- the third party report that replaces the Pop Images tab.
    OthersCampaign_view_to_fillRead = 'others.campaign_view_to_fill.read',
    OthersCampaign_booking_summariesNotesUpdate = 'others.campaign_booking_summaries_notes.update',
    OthersCampaign_booking_summariesNotesRead = 'others.campaign_booking_summaries_notes.read',

    // Shows a non-admin the customisable dashboard (2.0); admins use the profile-menu switch.
    ReportingDashboard_v2 = 'reporting.dashboard_v2',
}
